import React from 'react'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout'
import MapComponent from '@/components/Map/Map'
import { BackButton } from '@/components/layout/NavBar'

import './MyMap.css'

export const MyMapPage = ({ services, session }: { services: Services, session: CurrentSession }) => {
  return <LoggedInPageLayout pageName='my-map' services={services} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
    <MapComponent fetchUrl='/api/communal/my/map' services={services} session={session} />
  </LoggedInPageLayout>
}
